export const convertToServerDateFormat = ({ year, month, day, } = {}) => {
    if (!year || !month || !day)
        return null;
    return [year, month, day].join('-');
};
export const convertFromServerDateFormat = (serverDate = '') => {
    if (!serverDate)
        return {};
    const [year, month, day] = serverDate.split('-');
    return {
        day,
        month,
        year,
    };
};
//# sourceMappingURL=server-date-format.js.map